import { StrategyContent } from 'components/explorer/strategies/StrategyContent';

export const PortfolioStrategiesPage = () => {
  return <StrategyContent url="/portfolio" />;
};
